import { render, staticRenderFns } from "./modal-video.vue?vue&type=template&id=5e62df23"
import script from "./modal-video.vue?vue&type=script&lang=ts"
export * from "./modal-video.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports